import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { injectConfig, configShape } from '@client/hoc/config';
import Dialog from '@client/components/shared/Dialog';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { isClient } from '@client/helpers/index';
import { track } from '@client/helpers';

import OverlayContent from '../../shared/preliminaryOrderOverlay/OverlayContent';
import { getPreliminarySession } from '../../../redux/modules/preliminarySession/selectors';
import { cancelPreliminarySession } from '../../../redux/modules/preliminarySession/actions';
import { COUNTRIES } from '../../../config/constants';

const mapStateToProps = state => ({
    preliminarySession: getPreliminarySession(state)
});
const mapDispatchToProps = {
    cancelPreliminarySession
};

export class PreliminaryOrderOverlay extends PureComponent {
    static propTypes = {
        preliminarySession: PropTypes.object.isRequired,
        config: configShape
    };

    static defaultProps = {
        redirectToCheckout: config => {
            window.location.href = `${config.getUrl(
                'base'
            )}checkout/payment/show?retry=true`;
        },
        redirectToSuccess: config => {
            window.location.href = `${config.getUrl(
                'base'
            )}checkout/callback/success?retry=true`;
        }
    };

    render() {
        const { id } = this.props.preliminarySession;

        const showDialog = !!id;

        return (
            <Dialog isShown={showDialog} size={'wide'} wrapperNoPadding>
                <TranslationsScope path="preliminaryOrderOverlay">
                    <OverlayContent
                        showCreditCardSecurityInfo={
                            this.showCreditCardSecurityInfo
                        }
                        onChangePayment={this.paymentChange}
                        onCancelOrder={this.cancelOrder}
                        onAlreadyPayed={this.alreadyPayed}
                    />
                </TranslationsScope>
            </Dialog>
        );
    }

    componentDidMount() {
        if (isClient() && !!this.props.preliminarySession.id) {
            track('overlay_popup_preliminaryOrder');
        }
    }

    paymentChange = () => {
        const { config, redirectToCheckout } = this.props;

        return redirectToCheckout(config);
    };

    alreadyPayed = () => {
        const { config, redirectToSuccess } = this.props;

        return redirectToSuccess(config);
    };

    cancelOrder = () => {
        this.props.cancelPreliminarySession(this.props.preliminarySession.id);
    };

    get showCreditCardSecurityInfo() {
        const paymentMethod = this.props.preliminarySession.paymentMethod;
        const appdomain = this.props.config.appdomain;
        const isCreditCardPayment =
            paymentMethod === 'CREDIT_CARD' ||
            paymentMethod === 'CREDITCARD' ||
            paymentMethod === 'THREE_DS_CREDITCARD';
        const isEuropeanUnionDomain = !(appdomain ===
            COUNTRIES.SWITZERLAND || appdomain === COUNTRIES.SWITZERLAND_FR);

        return isCreditCardPayment && isEuropeanUnionDomain;
    }
}

export default injectConfig(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PreliminaryOrderOverlay)
);
